import React from 'react';
import { motion } from 'framer-motion';
import { DivineBackdrop, OrnateGoldBadge, GoldFooterPill, BODY_FONT_STYLE } from './shared';

const AnnouncementDisplay = ({ content }) => {
  const details = [content?.date, content?.time, content?.venue].filter(Boolean);
  const flyerUrl = content?.flyer?.image_url || content?.flyer_url || content?.image_url || '';
  const resolvedFlyer = flyerUrl
    ? (flyerUrl.startsWith('http') ? flyerUrl : `${process.env.REACT_APP_BACKEND_URL || ''}${flyerUrl}`)
    : '';
  return (
    <div className="w-full h-full relative overflow-hidden" data-testid="announcement-display" style={{ height: '100vh' }}>
      <DivineBackdrop />
      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-12">
        <motion.div initial={{ opacity: 0, y: -24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.55 }}>
          <OrnateGoldBadge>ANNOUNCEMENT</OrnateGoldBadge>
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, y: 22, filter: 'blur(10px)' }}
          animate={{ opacity: 1, y: 0, filter: 'blur(0px)' }}
          transition={{ delay: 0.2, duration: 0.7 }}
          className="text-white"
          style={{
            ...BODY_FONT_STYLE,
            fontSize: 'clamp(36px, 7vh, 96px)',
            lineHeight: 1.06,
            margin: '3.5vh 2vw 2vh',
            maxWidth: '85vw',
          }}
        >
          {content?.title || 'Announcement'}
        </motion.h1>

        {content?.description && (
          <motion.p
            initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.45, duration: 0.55 }}
            className="text-white/95"
            style={{
              ...BODY_FONT_STYLE,
              fontWeight: 800,
              fontSize: 'clamp(20px, 3.4vh, 40px)',
              maxWidth: '80vw',
              lineHeight: 1.3,
              whiteSpace: 'pre-wrap',
              margin: 0,
            }}
          >
            {content.description}
          </motion.p>
        )}

        {resolvedFlyer && (
          <motion.div
            initial={{ opacity: 0, scale: 0.96 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.6, duration: 0.6 }}
            style={{
              marginTop: '4vh',
              maxHeight: '52vh',
              maxWidth: '70vw',
              borderRadius: '24px',
              overflow: 'hidden',
              border: '2px solid rgba(251,191,36,0.55)',
              boxShadow: '0 0 60px rgba(251,191,36,0.25), 0 18px 60px rgba(0,0,0,0.55)',
              background: 'rgba(0,0,0,0.45)',
            }}
          >
            <img
              src={resolvedFlyer}
              alt={content?.title || 'Announcement flyer'}
              data-testid="announcement-flyer-live"
              style={{ display: 'block', maxHeight: '52vh', maxWidth: '70vw', objectFit: 'contain' }}
              onError={(e) => { e.currentTarget.style.display = 'none'; }}
            />
          </motion.div>
        )}

        {details.length > 0 && (
          <motion.div
            initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.7, duration: 0.55 }}
            className="flex flex-wrap items-center justify-center gap-3"
            style={{ marginTop: '5vh' }}
          >
            {details.map((d, i) => (
              <span
                key={i}
                className="rounded-full px-5 py-2 tracking-[0.15em] font-black"
                style={{
                  color: '#fde68a',
                  fontSize: 'clamp(14px, 2vh, 22px)',
                  border: '1.5px solid rgba(251,191,36,0.7)',
                  background: 'linear-gradient(180deg, rgba(16,32,74,0.75), rgba(6,12,30,0.75))',
                  boxShadow: '0 0 18px rgba(251,191,36,0.22)',
                  textShadow: '0 1px 3px rgba(0,0,0,0.7)',
                }}
              >
                {d}
              </span>
            ))}
          </motion.div>
        )}

        {content?.footer && (
          <motion.div
            initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.9, duration: 0.55 }}
            style={{ marginTop: '4vh' }}
          >
            <GoldFooterPill>{content.footer}</GoldFooterPill>
          </motion.div>
        )}
      </div>
    </div>
  );
};

export default AnnouncementDisplay;
